<template>
  <BittsSvg
    v-if="useSvgIcon"
    :svg="svgName"
    class="data-source-avatar"
    :class="sizeClass"
  />
  <BittsAvatar v-else :org="{ domain }" :size="size" />
</template>

<script setup lang="ts">
import { BittsAvatar, BittsSvg } from '@crossbeam/bitts';

import { computed } from 'vue';

import { DataSourceDomain, DataSourceSvgIcon } from '@/constants/data_sources';
import type { DataSourceType } from '@/types/feeds';

type AvatarSize = 'x-small' | 'small' | 'medium' | 'large';

const props = withDefaults(
  defineProps<{
    dataSource: DataSourceType;
    size?: AvatarSize;
  }>(),
  {
    size: 'x-small',
  },
);

const useSvgIcon = computed(() => props.dataSource in DataSourceSvgIcon);

const svgName = computed(() => DataSourceSvgIcon[props.dataSource] ?? '');

const domain = computed(() => DataSourceDomain[props.dataSource] ?? '');

const sizeClass = computed(() => `data-source-avatar--${props.size}`);
</script>

<style scoped lang="pcss">
@reference "../css/theme.css";

.data-source-avatar--x-small {
  @apply w-16 h-16;
}

.data-source-avatar--small {
  @apply w-24 h-24;
}

.data-source-avatar--medium {
  @apply w-32 h-32;
}

.data-source-avatar--large {
  @apply w-40 h-40;
}
</style>
